import { render } from "./ProductAdsCard.vue?vue&type=template&id=71cafced&scoped=true"
import script from "./ProductAdsCard.vue?vue&type=script&lang=js"
export * from "./ProductAdsCard.vue?vue&type=script&lang=js"

import "./productAdsCartStyle.scss?vue&type=style&index=0&id=71cafced&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cafced"]])

export default __exports__